export const GET_LESSON_RATINGS = 'lesson-ratings/GET_LESSON_RATINGS';
export const GET_LESSON_RATINGS_BY_STUDENT_ID =
  'lesson-ratings/GET_LESSON_RATINGS_BY_STUDENT_ID';
